import { useContext } from '@nuxtjs/composition-api';
import articlesGql from '../queries/articles.gql';
import { ArticlesQuery } from '../types';
import { UseArticlesInterface, UseArticlesLoadParams } from './useArticles';

export function useArticles(): UseArticlesInterface {
  const { app } = useContext();

  const load = async (params?: UseArticlesLoadParams) => {
    const { data } = await app.$vsf.$magento.api.customQuery(
      { query: articlesGql, queryVariables: params?.searchParams },
      params?.customQuery,
    ) as { data: ArticlesQuery };

    return data.getArticles;
  };

  return {
    load,
  };
}
